import { render, staticRenderFns } from "./ActiveCategory.vue?vue&type=template&id=51155bde&scoped=true&"
import script from "./ActiveCategory.vue?vue&type=script&lang=js&"
export * from "./ActiveCategory.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCategory.vue?vue&type=style&index=0&id=51155bde&prod&lang=scss&scoped=true&"
import style1 from "./ActiveCategory.vue?vue&type=style&index=1&id=51155bde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51155bde",
  null
  
)

export default component.exports